import Yup from '@fourthwall/utils/dist/yup'

export const validationSchema = Yup.object().shape({
  internalDomain: Yup.string().required(),
})
